import { getQRCodeURL } from "./ps";

export function getPaymentURL(
  serviceId: string,
  storeSlug: string,
  t?: string | number,
) {
  // 発行時刻。ブラウザが古い支払いURLを復元した際に、経過時間から失効させるために付与する
  const issuedAt = Date.now();
  const tag =
    t && t.toString().length > 0
      ? `?t=${t}&issuedAt=${issuedAt}`
      : `?issuedAt=${issuedAt}`;
  return getQRCodeURL(serviceId, `/pay/${storeSlug}${tag}`);
}
